import { SKU_CAT_PAD_LENGTH, SKU_ID_PAD_LENGTH, SKU_PAD_CHAR } from '@/constants'
import { CtCatalogue } from '@/models/interfaces/content-type'
import { SKU } from '@/models/interfaces/product'
import { $padString } from '@/utils'

export interface SKUSettings {
  SKU_PAD_CHAR: string,
  SKU_CAT_PAD_LENGTH: number,
  SKU_ID_PAD_LENGTH: number
}

export interface SkuCtrl {
  catalogue: CtCatalogue | undefined,
  settings: SKUSettings,
  display(sku: SKU | string | number): string
}

export function SkuController (catalogue:CtCatalogue | undefined, settings: SKUSettings = { SKU_CAT_PAD_LENGTH, SKU_ID_PAD_LENGTH, SKU_PAD_CHAR }): SkuCtrl {
  return {
    catalogue,
    settings,
    display (sku) {
      return `${this.catalogue?.sku_prepend ?? ''}${$padString((this.catalogue?.id ?? '').toString(), SKU_PAD_CHAR, SKU_CAT_PAD_LENGTH)}${this.catalogue?.sku_separator ?? ''}${$padString((sku || '').toString(), SKU_PAD_CHAR, SKU_ID_PAD_LENGTH)}${this.catalogue?.sku_append ?? ''}`
    }
  }
}
